import StoredLayout from '../../layouts/StoredLayout'
import Chartist from './Chartist'
export default StoredLayout(Chartist)



// WEBPACK FOOTER //
// ./src/charts/chartist/index.js